import { render } from "./SocialProfile.vue?vue&type=template&id=9921d2b4"
import script from "./SocialProfile.vue?vue&type=script&lang=js"
export * from "./SocialProfile.vue?vue&type=script&lang=js"

import exportComponent from "/home/www/omniauto/omninext/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__